import Table from '@/common/components/Table';
import ActionButton from '@/common/components/buttons/ActionButton';
import SupportMail from '@/common/components/supportMail/SupportMail';
import moment from 'moment';
import { Colors } from '../../../../../common/colors/colors';
import Input from '../../../../../common/components/Input';
import Loading from '../../../../../common/components/Loading';
import PopUp from '../../../../../common/components/PopUp';
import SelectInput from '../../../../../common/components/SelectInput';
import MoreInfo from '../../../contact/moreInfo/MoreInfo';
import TicketsForCalling from '../../../contact/tickets/TicketsForCalling';
import {
	ConfirmWrapper,
	ExtraShiftConfirmButtons,
	ExtraShiftConfirmSpan,
	Flex,
	Flex2,
	ItemsErrorTitle,
	Label,
	NotCreateFlex,
	VariantTableCell1,
	VariantTableCell2,
	VariantTableCell3,
	VariantTableHeadCenter,
	VariantTableHeadLeft,
	VariantTableWrapper,
} from './OrderEditInbound.styled';
import ConfirmInboundPayment from './components/ConfirmInboundPayment';
import { PAYMENT_LINK_HEADERS } from './constants/paymentLinkHeaders';
import useOrderEditInbound from './useOrderEditInbound';

const OrderEditInbound = ({
	order = { shipping: {} },
	setShow,
	contact,
	country,
	market,
	create = true,
	comments = [],
}) => {
	const hook = useOrderEditInbound({
		order,
		country,
		comments,
		setShow,
		contact,
		market,
		create,
	});

	return (
		<>
			<PopUp setShow={setShow} top={30}>
				{hook.isLoading && <Loading />}
				<Flex>
					<h2 style={{ marginBottom: '20px' }}>{hook.translation.order}</h2>
					<div style={{ display: 'flex', gap: '20px' }}>
						{!create && (
							<TicketsForCalling
								market={market}
								orderId={order._id.toString()}
							/>
						)}
						<MoreInfo
							changeColor
							product={hook.product?.short}
							email={contact.email}
							sendMail={hook.translation.send}
							order={order}
							mailError={hook.translation.mailError}
							mailSuccess={hook.translation.mailSuccess}
						/>
						<SupportMail order={order} />
					</div>{' '}
				</Flex>
				<div>
					<div style={{ display: 'flex' }}>
						<div>
							<h4 style={{ margin: '20px' }}>
								<u>{hook.translation.contactInfo}:</u>
							</h4>
							<Input
								inputRef={hook.nameRef}
								name={hook.translation.fullName}
								value={contact.full_name}
								required={true}
								width={100}
							/>
							<Input
								name={hook.translation.email}
								type='email'
								inputRef={hook.emailRef}
								value={contact.email}
								required={true}
								width={100}
							/>
							<Input
								name={hook.translation.phone}
								inputRef={hook.phoneRef}
								value={contact.phone_number}
								disabled
								width={100}
							/>
							<Input
								name={hook.translation.status}
								value={order.status}
								disabled
								width={100}
							/>
							{!create && (
								<NotCreateFlex>
									<div style={{ display: 'flex', gap: '20px' }}>
										<ActionButton
											color={Colors.orange}
											onClick={() => {
												hook.setType('informed');
												hook.setShowConfirm(true);
											}}
											defaultText={hook.translation.informed}
										/>
										<ActionButton
											disabled={!hook.wasCommentAdded}
											defaultText={hook.translation.resign}
											onClick={() => {
												hook.setType('resign');
												hook.setShowConfirm(true);
											}}
										/>
										<ActionButton
											disabled={!hook.wasCommentAdded}
											onClick={() => {
												hook.setType('shift');
												hook.setShowConfirm(true);
											}}
											defaultText={hook.translation.shift}
										/>
										<ActionButton
											defaultText={'Confirm Order Shipment'}
											disabled={!hook.wasCommentAdded}
											onClick={() => {
												hook.setType('confirm');
												hook.setShowConfirm(true);
											}}
										/>
										<ActionButton
											defaultText={'Confirm Order Payment'}
											disabled={!hook.wasCommentAdded}
											onClick={() => {
												hook.setShowPaymentConfirm(true);
											}}
										/>
									</div>
								</NotCreateFlex>
							)}
						</div>
						<div>
							<h4 style={{ margin: '20px' }}>
								<u>{hook.translation.shippingInfo}:</u>
							</h4>
							<Input
								inputRef={hook.suggestedDeliveryDateRef}
								type='date'
								name={hook.translation.suggested_delivery_date}
								value={hook.suggestedDeliveryDateInit}
								required={true}
								width={250}
							/>
							<Input
								inputRef={hook.streetRef}
								name={hook.translation.street}
								value={contact.street}
								required={true}
								width={250}
							/>
							<Input
								name={hook.translation.postalCode}
								inputRef={hook.postalCodeRef}
								value={contact.postal_code}
								required={true}
								width={250}
							/>
							<Input
								name={hook.translation.city}
								inputRef={hook.cityRef}
								value={contact.city}
								required={true}
								width={250}
							/>
							<SelectInput
								name={hook.translation.country}
								selected={hook.selectedCountry}
								setSelected={hook.setSelectedCountry}
								width={250}
								options={hook.COUNTRIES}
							/>
							<Input
								name={hook.translation.countryCode}
								value={
									hook.selectedCountry.value
										? hook.selectedCountry.value
										: country.value
								}
								width={250}
								disabled={true}
							/>
							<SelectInput
								name={hook.translation.courier}
								selected={hook.selectedCourier}
								setSelected={hook.setSelectedCourier}
								options={hook.courierOptions}
								width={250}
							/>
							{hook.selectedCourier?.rest?.type === 'pickup' &&
								hook.pointsOptions?.length > 0 && (
									<SelectInput
										selected={hook.selectedPoint}
										setSelected={hook.setSelectedPoint}
										options={hook.pointsOptions}
										name={hook.translation.pickup_point}
										width={250}
									/>
								)}
						</div>
					</div>
					<div>
						<h4 style={{ margin: '20px' }}>
							<u>{hook.translation.items}:</u>
						</h4>
						<Flex2
							style={{
								justifyContent: hook.product ? 'center' : 'flex-start',
								flexWrap: hook.product ? 'nowrap' : 'wrap',
							}}
						>
							{hook.product ? (
								<Label>
									<strong style={{ marginRight: '20px' }}>
										{hook.translation.name}:
									</strong>{' '}
									{hook.product.name}
								</Label>
							) : (
								<div style={{ width: '100%', display: 'flex' }}>
									<SelectInput
										name='Product'
										width={80}
										setSelected={hook.selectProduct}
										options={hook.availableProductsOptions}
									/>
								</div>
							)}
							<SelectInput
								name={hook.translation.variant}
								width={80}
								selected={hook.selectedOption}
								setSelected={hook.setSelectedOption}
								options={hook.product?.variants.map((varaint) => {
									return { label: varaint.name, value: varaint.short };
								})}
							/>
							<SelectInput
								name={hook.translation.price}
								width={40}
								selected={hook.selectedOptionPrice}
								setSelected={hook.setSelectedOptionPrice}
								options={hook.product?.prices.map((price) => {
									return { label: price.value, value: price.value };
								})}
							/>
							<div style={{ display: 'flex', justifyContent: 'right' }}>
								<ActionButton
									onClick={(e) => hook.handleAddProduct(e)}
									defaultText={hook.translation.add}
								/>
							</div>
						</Flex2>
						{hook.chosenVariants.length > 0 && (
							<VariantTableWrapper>
								<table>
									<thead>
										<tr>
											<VariantTableHeadLeft>
												{hook.translation.variant}
											</VariantTableHeadLeft>
											<VariantTableHeadCenter>
												{hook.translation.short}
											</VariantTableHeadCenter>
											<VariantTableHeadCenter>
												{hook.translation.price}
											</VariantTableHeadCenter>
											<VariantTableHeadCenter></VariantTableHeadCenter>
										</tr>
									</thead>
									<tbody>
										{hook.chosenVariants.map((data) => (
											<tr style={{}}>
												<VariantTableCell1>{data.name}</VariantTableCell1>
												<VariantTableCell2>{data.value}</VariantTableCell2>
												<VariantTableCell2>
													{data.price} {market.currency}
												</VariantTableCell2>
												<VariantTableCell3>
													<ActionButton
														onClick={(e) =>
															hook.handleDelteProductItem(e, data._id)
														}
														style={{ background: 'none', border: 'none' }}
													>
														<i
															class='fa fa-remove'
															style={{ color: 'red', fontSize: '20px' }}
														/>
													</ActionButton>
												</VariantTableCell3>
											</tr>
										))}
									</tbody>
								</table>
							</VariantTableWrapper>
						)}
					</div>
					<div>
						<h4 style={{ margin: '20px' }}>
							<u>Online Payments:</u>
						</h4>
					</div>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<Table
							className='styled-table'
							headers={PAYMENT_LINK_HEADERS}
							raws={hook.paymentsData}
						/>
					</div>
					{create ? (
						<div
							style={{ display: 'flex', justifyContent: 'right', gap: '10px' }}
						>
							<ActionButton
								style={{ float: 'right' }}
								text={'Create Online Payment'}
								onClick={(e) => hook.handleSaveOrderOnlinePayment(e)}
							/>
							<ActionButton
								style={{ float: 'right' }}
								text={'Create Shipping'}
								onClick={(e) => hook.handleSaveOrder(e)}
							/>
						</div>
					) : (
						<ActionButton
							style={{ float: 'right' }}
							text={hook.translation.save}
							onClick={(e) => hook.handleSaveOrder(e)}
						/>
					)}
				</div>
			</PopUp>
			{hook.showConfirm && (
				<PopUp setShow={hook.setShowConfirm}>
					<h5>Do you want to mark order as {hook.type}?</h5>
					<ConfirmWrapper>
						{hook.type === 'shift' && (
							<input
								onChange={(e) => hook.setShiftDate(e.target.value)}
								type='datetime-local'
								defaultValue={hook.shiftDate}
							/>
						)}
						<ActionButton
							onClick={() => hook.setShowConfirm(() => false)}
							defaultText='no'
						/>
						<ActionButton
							onClick={(e) =>
								hook.type === 'shift'
									? hook.setShowExtraShiftConfirm(true)
									: hook.handleMarkAsConsultantDecision(e)
							}
							color={Colors.green}
							defaultText='yes'
						/>
					</ConfirmWrapper>
				</PopUp>
			)}
			{hook.showExtraShiftConfirm && (
				<PopUp setShow={hook.setShowExtraShiftConfirm}>
					<p style={{ fontSize: '32px' }}>
						NOW YOU ARE SELECTING: <br />
						<ExtraShiftConfirmSpan>
							{moment(hook.shiftDate).format('YYYY-MM-DD HH:mm')}
						</ExtraShiftConfirmSpan>
					</p>
					<h5>Are you sure you want to shift order?</h5>
					<ExtraShiftConfirmButtons>
						<ActionButton
							onClick={() => hook.setShowExtraShiftConfirm(() => false)}
							defaultText='no'
						/>
						<ActionButton
							onClick={(e) => hook.handleMarkAsConsultantDecision(e)}
							color={Colors.green}
							defaultText='yes'
						/>
					</ExtraShiftConfirmButtons>
				</PopUp>
			)}
			{hook.itemsError && (
				<PopUp setShow={hook.setItemsError}>
					<ItemsErrorTitle>
						{hook.itemsError === 'item'
							? 'You cannot confirm order if there is no items!!!'
							: 'If there is no promotion the starting price should be 5x higher'}
					</ItemsErrorTitle>
				</PopUp>
			)}
			{hook.showPaymentConfirm && (
				<ConfirmInboundPayment
					data={order}
					setClose={hook.setShowPaymentConfirm}
					setShow={setShow}
				/>
			)}
		</>
	);
};

export default OrderEditInbound;
